module.exports = __webpack_public_path__ + "img/head.b531b7b1.png";